import * as React from 'react';

import { addModifiers } from '../../shared/helpers';

interface ContainerProps {
  children: JSX.Element[] | JSX.Element | string;
  id?: string;
  modifiers?: string[];
}

const Container = ({ children, id, modifiers = [] }: ContainerProps) => (
  <div id={id} className={addModifiers('o-container', modifiers)}>
    {children}
  </div>
);

export default Container;
